import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IFieldModel } from '../../../../../../models/blueprint/blueprint-field.model';
import { IBluePrintModel } from '../../../../../../models/blueprint/blueprint.model';
import { DashboardHelper } from '../../../../../../services/dashboard.service';
import { Helper } from '../../../../../../services/helper.service';
import { FieldDropdownMultipleModel, IFieldDropdownMultipleModel } from '../../../../../../models/blueprint/blueprint-field-dropdown-multiple.model';
import { UiStateStore } from '../../../../../../services/stores/ui-state.store';
import { PatchFieldPayload } from '../../../../../../models/field/patch-field-payload.model';
import { AlertService } from '../../../../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from 'angular2-notifications';
import { NgForm } from '@angular/forms';
import { BluePrintAPIService } from '../../../../../../services/api/blueprint.api.service';
import { BlueprintDataHelper } from '../../../../../../services/helpers/blueprint-data.helper';
import { BlueprintStore } from '../../../../../../services/stores/blueprint.store';
import { UserService } from '../../../../../../services/user.service';
import { PermissionService } from '../../../../../../services/permission.service';

@Component({
  selector: 'app-blueprint-field-dropdown-multiple',
  templateUrl: './blueprint-field-dropdown-multiple.component.html',
  styleUrls: ['./blueprint-field-dropdown-multiple.component.css'],
  standalone: false,
})
export class BlueprintFieldDropdownMultipleComponent implements AfterViewInit, OnDestroy {
  selectedBluePrintField: IFieldModel = {} as IFieldModel;
  selectedBluePrintFieldOldVal: IFieldModel = {} as IFieldModel;
  dropdownMultipleField: IFieldDropdownMultipleModel = {} as IFieldDropdownMultipleModel;
  selectedBluePrint: IBluePrintModel = {} as IBluePrintModel;
  dropdownOptions: string = '';
  oldName: string = '';
  public subscribers: any = {};
  @ViewChild('inputName') inputNameElement!: ElementRef;
  @ViewChild('myForm') myForm!: NgForm;

  constructor(
    private dashboardHelper: DashboardHelper,
    private bluePrintService: BluePrintAPIService,
    private bluePrintStore: BlueprintStore,
    private uiStateStore: UiStateStore,
    private helperService: Helper,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private bluePrintHelper: BlueprintDataHelper,
    private alertService: AlertService,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {
    console.log('BlueprintFieldDropdownSingleComponent');
  }

  public get isReadOnly(): boolean {
    if (this.permissionService.isSysAdmin) {
      return false;
    }
    const blueprintOrgId = this.selectedBluePrint?.organizationId?.toLowerCase();
    const userOrgId = this.userService.user?.organizationId?.toLowerCase();
    if (!blueprintOrgId || !userOrgId) {
      // Unknown org on either side - fail closed (read-only) rather than treat two empty/missing
      // org ids as a match.
      return true;
    }
    return blueprintOrgId !== userOrgId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subscribers.bp = this.bluePrintStore.$selectedBluePrint.subscribe((bp) => {
        if (bp) {
          this.selectedBluePrint = bp;
          if (!this.bluePrintStore.selectedBluePrintField) {
            this.subscribers.params = this.route.params.subscribe((params) => {
              if (params['id']) {
                if (this.selectedBluePrint) {
                  const blueprintField = this.selectedBluePrint.fields.find((field) => field.id === params['id']);
                  if (blueprintField) this.bluePrintStore.selectedBluePrintField = blueprintField;
                  this.dashboardHelper.setShowRightPanel(true);
                }
              }
            });
          }
        }
      });

      this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility) => {
        if (panelVisibility === false) {
          // If right side panel is closed without saving then reset to previous value
          if (this.selectedBluePrint && this.selectedBluePrintFieldOldVal) {
            const oldField = this.selectedBluePrint.fields.find((f) => f.id === this.selectedBluePrintFieldOldVal.id);
            if (oldField) this.selectedBluePrint.fields[this.selectedBluePrint.fields.indexOf(oldField)] = this.selectedBluePrintFieldOldVal;
            if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
              this.myForm.form.markAsPristine();
              this.cdr.detectChanges();
            }
          }
        }
      });

      this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
        if (this.selectedBluePrintField && this.selectedBluePrintField.id !== result) {
          if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
            this.myForm.form.markAsPristine();
            this.saveWork(false);
          }
        }
      });

      this.subscribers.bpfield = this.bluePrintStore.$selectedBluePrintField.subscribe((result) => {
        this.dropdownOptions = '';
        if (result) this.selectedBluePrintField = result;
        this.selectedBluePrintFieldOldVal = this.helperService.getDeepCopy(result);
        if (this.selectedBluePrintField) {
          this.oldName = this.selectedBluePrintField.name;
          if (!this.selectedBluePrintField.value) {
            this.dropdownMultipleField = new FieldDropdownMultipleModel(false, false, [], '');
            this.selectedBluePrintField.value = this.dropdownMultipleField;
          } else {
            this.dropdownMultipleField = <IFieldDropdownMultipleModel>this.selectedBluePrintField.value;
          }
          if (this.dropdownMultipleField.options) {
            this.dropdownOptions = this.dropdownMultipleField.options.join('\n');
          }
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();

    if (this.subscribers) {
      if (this.subscribers.bpfield) {
        this.subscribers.bpfield.unsubscribe();
      }
      if (this.subscribers.bp) {
        this.subscribers.bp.unsubscribe();
      }
      if (this.subscribers.params) {
        this.subscribers.params.unsubscribe();
      }
      if (this.subscribers.rightPanelVisible) {
        this.subscribers.rightPanelVisible.unsubscribe();
      }
      if (this.subscribers.selectedItemChanged) {
        this.subscribers.selectedItemChanged.unsubscribe();
      }
    }
  }

  public selectName() {
    const value = this.inputNameElement?.nativeElement?.value?.toLowerCase() ?? '';
    if (value.startsWith('dropdownmultiple')) {
      this.inputNameElement?.nativeElement?.select();
    }
  }

  public saveWork(updateResponse: boolean = true) {
    if (this.isReadOnly) {
      return;
    }
    this.bluePrintHelper.validateName(this.oldName, 'field');

    if (this.dropdownOptions !== undefined) {
      this.dropdownMultipleField.options = this.dropdownOptions.split('\n');

      // remove empty string items
      this.dropdownMultipleField.options = this.dropdownMultipleField.options.filter((e) => e.trim() !== '');

      if (this.dropdownMultipleField.options.length > 0) {
        const patchPayload: PatchFieldPayload = new PatchFieldPayload();
        patchPayload.bluePrintId = this.selectedBluePrint.id;
        patchPayload.field = this.selectedBluePrintField;
        patchPayload.updateResponse = updateResponse;
        this.selectedBluePrintFieldOldVal = this.selectedBluePrintField;
        // Dispatching the save clears dirty: the deselect auto-save (selectedItem subscription)
        // fires on a dirty form and would otherwise re-send this same patch, writing a second
        // identical 'blueprint modified' activity log entry (ZOO-10065).
        this.myForm?.form.markAsPristine();
        this.uiStateStore.startBackendAction('Saving DropDownMultiple...');
        this.bluePrintService.patchField(patchPayload).subscribe({
          next: (result) => {
            this.uiStateStore.endBackendAction('DropDownMultiple saved!');
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.uiStateStore.endBackendAction('Error saving DropDownMultiple');
            this.myForm?.form.markAsDirty(); // save failed - keep the edit re-savable
            this.cdr.detectChanges();
          },
        });
      } else {
        this.dropdownOptions = '';
        this.alertService.alert(NotificationType.Warn, 'Please Enter Options', true);
      }
    } else if (this.dropdownOptions === undefined) {
      this.dropdownOptions = '';
      this.alertService.alert(NotificationType.Warn, 'Please Enter Options', true);
    }
    // this.uiHelper.closeRightPanel(this.router);
  }

  public onChange() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      return;
    }
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedBluePrintField.id,
      name: this.selectedBluePrintField.name,
    });
  }

  public onNameBlur() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      this.selectedBluePrintField.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedBluePrintField.id,
        name: this.selectedBluePrintField.name,
      });
    } else {
      this.bluePrintHelper.validateName(this.oldName, 'field');
      this.oldName = this.selectedBluePrintField.name;
    }
  }
}
